<template>
    <modal id="update-note-modal">

        <template slot="title">Update Note</template>

        <template slot="body">
            <field-text v-model="form.note"
                        :maxlength="2000"
                        :display-remaining-characters="false"
                        placeholder="Update your comments here...."
                        :with-placeholder="true">
            </field-text>
        </template>

        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal('update-note-modal')">
                Cancel
            </button>
            <button class="btn btn-success" @click="save()" :disabled="form.isSubmitted">
                <span v-if="!form.isSubmitted">Update</span>
                <span v-else><i class="fa fa-spin fa-spinner"></i> Updating...</span>
            </button>
        </template>

    </modal>
</template>
<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true,
            },
            url: {
                type: String,
                required: true,
            }
        },

        data() {
            return {
                note: this.value,
                form: new Form(this.value, false)
            }
        },

        methods: {
            save() {
                this.form.patch(`${this.url}/${this.note.id}`).then(response => {
                    this.$emit('input', response)
                    this.closeModal('update-note-modal')
                    Toast.success('Your note was updated successfully!')
                }).catch(errors => {
                    Toast.error(errors.first());
                })
            }
        },

        watch: {
            value: {
                deep: true,
                handler() {
                    this.note = this.value
                    this.form = new Form(this.value, false)
                }
            }
        }
    }
</script>
